import { findFirstValueDefined, hasAnyProp } from "@dirootie-toolbox/objects";
import { isArray, isUndefined } from "ramda-adjunct";
import { Initials } from "taltech-styleguide";

export type SummaryResource = {
  id: string;
  displayName: string;
  description?: string;
  pictureUrl?: string;
  url?: string;
};

const possiblePicturePaths = [
  "picture.url",
  "picture.path",
  "user.picture.url",
  "user.picture.path",
];

export const hasImage = hasAnyProp(possiblePicturePaths);
export const getImage = (obj: any) =>
  findFirstValueDefined<string>(possiblePicturePaths, obj, "");

const possibleTextPaths = ["name", "displayName", "title"];
export const hasName = hasAnyProp(possibleTextPaths);
export const getName = (obj: any) => {
  if (obj.firstName) return `${obj.firstName} ${obj.lastName}`;
  else if (obj.displayName) return obj.displayName;
  else if (obj.name) return obj.name;
  else if (obj.title) return obj.title;
};

export const hasValidImageExtension = (filename: string) => {
  const validExtensions = [".jpg", ".jpeg", ".png"];
  return validExtensions.some((extension) =>
    filename.toLowerCase().endsWith(extension)
  );
};

export const colInitialsImage = (row: any) => {
  const imgUrl = getImage(row);
  const name = getName(row);

  return hasValidImageExtension(imgUrl) ? (
    <Initials
      className={"m-1"}
      imageUrl={imgUrl}
      name={name}
      key={row.id}
      size="xs"
    />
  ) : (
    <Initials className={"m-1"} name={name} key={row.id} size="xs" />
  );
};

export const colInitialsText = (row: any) => (
  <Initials className={"m-1"} name={getName(row)} key={row.id} size="xs" />
);

export const colInitials = {
  classes: "ebd-initials-first",
  dataField: "picture.url",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return colInitialsImage(row);
  },
  sort: false,
  text: "",
};

export const colInitialsList = {
  classes: "ebd-initials-first",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    if (isUndefined(row?.lecturers) || !isArray(row?.lecturers)) {
      //TODO: log when there are not lecturers - error
      return <></>;
    }
    const lecturers = row.members.filter(
      (member: any) => member.role === "LECTURER" || member.role === "Lecturer"
    );
    // TODO: CHECK THIS LATER
    lecturers.forEach((x: any) => {
      if (x.user === null) {
        x.displayName = "L";
        return;
      }
      x.displayName = x.user.displayName;
    });
    return (
      <>
        {" "}
        <div className="ebd-initials-column">
          {lecturers.map((x: any) => {
            return (
              <div key={x.id} className={"ebd-initials"}>
                {colInitialsImage(x)}
              </div>
            );
          })}
          <div className={"ebd-last-initial"}>
            {/* <div>
              <Initials
                className={"m-1"}
                key={row.lecturers[0].id}
                name={row.lecturers[0].displayName}
                imageUrl={row.lecturers[0].pictureUrl}
                size="xs"
              />
            </div>
            <div className={"ebd-remaining-initials"}>
              +{row.lecturers.length - 4}
            </div> */}
          </div>
        </div>
      </>
    );
  },
  sort: false,
  text: "Lecturers",
};
